import React, { Component, PropTypes } from 'react';

import { Deck } from 'spectacle-ppa';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './index.md';

import start from './sections/01_start/startSection';
import song from './sections/03_song/songSection';
import missionReport from
  './sections/11_missionReport/missionReportSection';
import esOpeningStory from './sections/12_esOpeningStory/esOpeningStorySection';
import gameShow from './sections/20_gameShow/gameShowSection';
import mme from './sections/13_mme/mmeSection';
import classActivity from './sections/30_classActivity/classActivitySection';
import esClosingStory from './sections/60_esClosingStory/esClosingStorySection';
import missionAssignment from
  './sections/70_missionAssignment/missionAssignmentSection';
import finishHackedSection from
  './sections/91_finishHacked/finishHackedSection';

const md = new MarkdownScript(markdownFile);
const level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
const title = md.getSectionMetadata(`Level ${level}`, 'Title');

export default class extends Component {

  static contextTypes = {
    regionData: PropTypes.object.isRequired
  };

  static metadata = {
    title
  };

  render() {
    const { regionData } = this.context;
    return (
      <Deck transition={['slide']}
            transitionDuration={800}
            progress="bar">

        {/* Start */}
        {start({ level, title, regionData })}

        {/* Theme Song */}
        {song({ level, regionData })}

        {/* Mission Report */}
        {missionReport({ level, regionData })}

        {/* Esmeralda Opening Story */}
        {esOpeningStory({ level, regionData })}

        {/* Game Show */}
        {gameShow({ level, regionData })}

        {/* Messages from Mother Earth */}
        {mme({ level, regionData })}

        {/* Class Activity: Lunch Analysis */}
        {classActivity({ level, subActivity: 'a', regionData })}

        {/* Class Activity: Collective Impact Math */}
        {classActivity({ level, subActivity: 'b', regionData })}

        {/* Class Activity: Waste-Free Lunch Poster */}
        {classActivity({ level, subActivity: 'c', regionData })}

        {/* Mission Assignment is before Es Closing Story because of hack */}
        {missionAssignment({ level, title, regionData })}

        {/* Esmeralda Closing Story */}
        {esClosingStory({ level, regionData })}

        {/* Finish section in level 4 involves a hack */}
        {finishHackedSection({ level, regionData })}

      </Deck>
    );
  }

}



// WEBPACK FOOTER //
// ./programs/zeroHeroes/level4.jsx